import { AnalyticsEvent } from "@common/constants/analytics-events";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const trackEventBodySchema = z.object({
    name: z.nativeEnum(AnalyticsEvent),
    properties: z.record(z.unknown()).optional(),
});

export const trackingContract = c.router(
    {
        trackEvent: {
            method: "POST",
            path: "/e",
            body: trackEventBodySchema,
            responses: {
                204: c.noBody(),
                400: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/t",
    },
);
